<script>
import formatDate from '@utils/format-date'



export default {

  components: {

  },
  filters: {
    formatDate,
  },
  props: {
    memberInfoId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      despoitList: [],
      depositType: {
        charge: {
          text: '儲值',
          color: 'text-success'
        },
        paid:{
          text: '抵扣',
          color: 'text-danger'
        },
        withdraw: {
          text: '結清為現金',
          color: 'text-success'
        },
        refund: {
          text: '退款為儲值金',
          color: 'text-success'
        },
      },
    }
  },
  computed: {

  },
  watch: {
    // currentPage: {
    //   handler: 'tryToSearchOrder',
    //   immediate: true,
    // },
  },
  created() {
    this.tryToFetchList()
  },
  mounted() {

  },
  methods: {
    async tryToFetchList(type) {
      this.tryingFetch = true

      const { items } = await this.$store.dispatch('deposit/fetchHistoryList', { 
        page: 0,
        member_id: this.memberInfoId,
        order: "desc",
        paginate: 0
      })

      this.despoitList = items
      this.tryingFetch = false
    },
  },
}
</script>

<template>
  <div :class="$style.MemberOrdersDespoit">
    <template v-if="despoitList.length > 0">
      <div v-loading="tryingFetch">
        <ul class="list-unstyled MemberOrdersDespoit__list">
          <li 
            v-for="(item,index) in despoitList"
            :key="index"
            class="MemberOrdersDespoit__item"
          >
            <div :class="depositType[item.type].color" class="mb-2 Jost">
              {{ item.total }}
            </div>
            <div class="mb-2 Jost">{{ item.createdAt|formatDate('dateTime') }}</div>
            <div class="text-secondary">{{ depositType[item.type].text }} : {{ item.extraInfo.price_title }}</div>
          </li>
        </ul>
      </div>
    </template>
    <template v-else>
      尚未使用儲值
    </template>
  </div>
</template>

<style lang="scss" module>
.MemberOrdersDespoit {
  :global {
    .MemberOrdersDespoit {
      &__item {
        position: relative;
        padding-left: 2.2rem;
        &:not(:last-child) {
          padding-bottom: 2.5rem;
          &::after {
            display: block;
          }
        }
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          height: 15px;
          width: 15px;
          background-color: $color-primary;
          border-radius: 100%;
          z-index: 2;
        }
        &::after {
          content: '';
          position: absolute;
          left: 7px;
          top: 0;
          bottom: 0;
          height: 100%;
          width: 1px;
          background-color: #E5E7EB;
          display: none;
        }
      }
    }
  }
}
</style>
